var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_423_35680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0617 5.13306C22.2461 5.49399 21.3742 5.73774 20.4555 5.85024C21.393 5.28774 22.1148 4.39712 22.4523 3.33774C21.5758 3.85806 20.6055 4.23774 19.5695 4.43931C18.7398 3.55337 17.5586 3.00024 16.2555 3.00024C13.7477 3.00024 11.718 5.03462 11.718 7.54243C11.718 7.89868 11.7555 8.24556 11.8352 8.57837C8.06172 8.39087 4.71484 6.58149 2.47891 3.82993C2.08984 4.50024 1.86484 5.28306 1.86484 6.11274C1.86484 7.68774 2.67109 9.07993 3.88984 9.89556C3.13984 9.87681 2.43672 9.67056 1.82734 9.32837V9.38462C1.82734 11.5877 3.39297 13.4206 5.46953 13.8377C5.08984 13.9409 4.68672 13.9971 4.27422 13.9971C3.98359 13.9971 3.69766 13.969 3.42109 13.9127C3.99766 15.7174 5.67578 17.0299 7.66328 17.0674C6.11172 18.2862 4.15234 19.0127 2.02422 19.0127C1.65859 19.0127 1.29766 18.9893 0.941406 18.9471C2.94297 20.2502 5.32891 21.0002 7.88828 21.0002C16.2461 21.0002 20.8117 14.0768 20.8117 8.07212C20.8117 7.87524 20.807 7.67837 20.7977 7.48618C21.6836 6.84399 22.4523 6.04712 23.0617 5.13306Z",
    fill: "#DFE1E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_423_35680",
    x: 0.941406,
    y: 3.00024,
    width: 22.1201,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_423_35680"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.cb09da5a1ac63c9406791a81580c70d3.svg";
export { ForwardRef as ReactComponent };